import type { AutosuggestProps } from '@risk-smart/themed-cloudscape-components/autosuggest';
import CSAutosuggest from '@risk-smart/themed-cloudscape-components/autosuggest';
import { forwardRef, useMemo } from 'react';

import { filterOptionsByVisibleText } from '../option-label-filter/filterOptionsByVisibleText';

// Cloudscape's Autosuggest built-in filter matches against
// ['value', 'label', 'description', 'labelTag', 'tags', 'filteringTags'] (see
// node_modules/@cloudscape-design/components/autosuggest/utils/utils.js
// `matchSingleOption`). If a caller passes UUID-valued options the same
// hex/digit leak described in RSP-5284 applies. Swap 'auto' to 'manual' and
// pre-filter on visible fields only. Autosuggest's `value` prop is the
// current input text, so we can use it directly without tracking separate
// filter state.
const Autosuggest = forwardRef<AutosuggestProps.Ref, AutosuggestProps>(
  ({ filteringType = 'auto', options, value, ...props }, ref) => {
    const preFilter = filteringType === 'auto';

    const visibleOptions = useMemo(
      () => (preFilter ? filterOptionsByVisibleText(options, value) : options),
      [options, value, preFilter]
    );

    return (
      <CSAutosuggest
        {...props}
        value={value}
        filteringType={preFilter ? 'manual' : filteringType}
        options={visibleOptions}
        ref={ref}
      />
    );
  }
);
Autosuggest.displayName = 'Autosuggest';

export default Autosuggest;
